import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from 'react-modal';
import ModalCloseButton from './ModalCloseButton';
import ModalContent from './ModalContent';

const FormSwiftModal = (props) => {
  const {
    children,
    className,
    closeOnOverlayClick,
    handleCloseModal,
    isCloseButtonVisible,
    isOpen,
    onAfterOpen,
  } = props;

  const modalClasses = classNames(
    'ds-modal-default',
    className,
  );

  const modalOverlayClasses = classNames(
    'ds-modal-overlay',
    `${className}-overlay`,
  );

  return (
    <Modal
      ariaHideApp={false}
      className={modalClasses}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={closeOnOverlayClick}
      onAfterOpen={onAfterOpen}
      onRequestClose={handleCloseModal}
      overlayClassName={modalOverlayClasses}
    >
      <ModalContent>
        <ModalCloseButton
          isCloseButtonVisible={isCloseButtonVisible}
          onClick={handleCloseModal}
        />
        {children}
      </ModalContent>
    </Modal>
  );
};

FormSwiftModal.defaultProps = {
  children: null,
  className: '',
  closeOnOverlayClick: true,
  isCloseButtonVisible: true,
  onAfterOpen: null,
  secondaryCta: {},
  tertiaryBtn: {},
};

FormSwiftModal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeOnOverlayClick: PropTypes.bool,
  handleCloseModal: PropTypes.func.isRequired,
  isCloseButtonVisible: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onAfterOpen: PropTypes.func,
};

export default FormSwiftModal;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/index.jsx